import { firebaseFunctions } from '@/services/firebase'

// firebaseFunctions.useEmulator('localhost', 5001)
const createCheckoutSession = firebaseFunctions.httpsCallable('createCheckoutSession')
const createBillingPortalSession = firebaseFunctions.httpsCallable('createBillingPortalSession')
const sendPaymentInfoEmail = firebaseFunctions.httpsCallable('sendPaymentInfoEmail')
const getCoupon = firebaseFunctions.httpsCallable('getCoupon')

export { createBillingPortalSession, createCheckoutSession, getCoupon, sendPaymentInfoEmail }
